/**
 * Given a fetch-like function, return a new one which takes an array of requests
 * and fetches them in parallel.
 */
export default function batch<T>(
  f: (path: string, init?: RequestInit) => Promise<T>,
): (inputs: string[], init: RequestInit) => Promise<T[]> {
  return (inputs: string[], init?: RequestInit) => {
    return Promise.all(inputs.map(input => f(input, init)));
  };
}
